import React from 'react'
import axios from "axios";
import { useState } from 'react';
import { Button, Form, FloatingLabel } from 'react-bootstrap';
import { Link } from 'react-router-dom';


    const IntelligenceInsight = () => {
        const [name, setName] = useState('')
        const [email, setEmail] = useState('')
        const [number, setNumber] = useState('')
        const [company, setCompany] = useState('')
        const [statusCode, setStatusCode] = useState('')
        const [message, setMessage] = useState('')
    
    const API_PATH = 'http://amosta.com/reactJs/IntelligenceInsight.php';
    function axios2() {
    
    axios({
      method: 'post',
      url: API_PATH,
      headers: {
        'content-type': 'application/json'
    
      },
      data: {
        "name": name,
        "email": email,
        "number": number,
        "company": company
    
      }
    })
      .then(result => {
        if (result.data.statusCode === 200) {
          setStatusCode(result.data.statusCode)
          setMessage(result.data.message)
          window.location.reload(false)
        } else {
          setStatusCode(result.data.statusCode)
          setMessage(result.data.message)
        }
        console.log(result);
      })
      .catch(error => {
        console.log(error)
      });
    }
    return (
        <div>
            <img className='img-fluid gst-software-main-banner' src="./assets/images/intelligence-insight-banner.jpg" alt="" />
            <div className="container gst-software-section-2">
                <div className="row">
                    <div className="col-sm-12 col-md-6">
                        <h2 className=''>Intelligence Insight for Efficient Compliance</h2>
                        <div className="container mt-5">
                            <ul>
                                <li>File GST Return before Due Date</li>
                                <li>Easy Cash Flow Management</li>
                                <li>Early Reminders to Avoid Penalty</li>
                                <li>Identify Items with Incorrect GST Classification</li>
                            </ul>

                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <div className="container gst-software-first-form p-5 bg-white text-dark text-center border-0 rounded-2 shadow-lg w-75" style={{ marginTop: '150px' }}>
                        <h5>{statusCode}</h5>
                        <h5>{message}</h5>
                            <Form autoComplete="off">
                                <h3 className='mb-3'>Request a Call</h3>
                                <FloatingLabel controlId='fullName' label='Full Name' className='mb-3'>
                                    <Form.Control type='text' placeholder='Full Name' id='name' name="name" onChange={(e) => setName(e.target.value)} required />
                                </FloatingLabel>
                                <FloatingLabel controlId='phone' label='Mobile Number' className='mb-3'>
                                    <Form.Control type='number' placeholder='Phone number' id='number' name="number" onChange={(e) => setNumber(e.target.value)} required />
                                </FloatingLabel>
                                <FloatingLabel controlId='emailId' label='Email Id' className='mb-3'>
                                    <Form.Control type='email' placeholder='name@example.com' id='email' name="email" onChange={(e) => setEmail(e.target.value)} required />
                                </FloatingLabel>
                                <FloatingLabel controlId='companyName' label='Company Name' className='mb-3'>
                                    <Form.Control type='text' placeholder='Company Name' id='company' name="company" onChange={(e) => setCompany(e.target.value)} required />
                                </FloatingLabel>
                                <Button type="button" onClick={axios2} className='text-center mt-3' variant='success'>Submit</Button>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-light">
                <div className="container section-5-gst-software mt-5 p-3 text-center">
                    <h2>Key Features of Intelligence Insight</h2>
                    <div className="section-5-gst-software-cards mt-5 p-3">

                        <div className="row">
                            <div className="col-sm-6 col-md-4">
                                <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                    <div className="card-head">
                                        <img className='img-fluid w-50 m-3 w-25' src="./assets/images/invoice.png" alt="" />
                                    </div>
                                    <div className="card-body ">
                                        <p>Top suppliers and customers</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-4">
                                <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                    <div className="card-head">
                                        <img className='img-fluid w-50 m-3' src="./assets/images/tax (1).png" alt="" />
                                    </div>
                                    <div className="card-body ">
                                        <p>GST filing timing and impact of cash flow improvement available</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-4">
                                <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                    <div className="card-head">
                                        <img className='img-fluid w-50 m-3' src="./assets/images/integration.png" alt="" />
                                    </div>
                                    <div className="card-body ">
                                        <p>Gain oversight of key countries of trade if there are foreign invoices</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-4">
                                <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                    <div className="card-head">
                                        <img className='img-fluid w-50 m-3' src="./assets/images/cloud-based.png" alt="" />
                                    </div>
                                    <div className="card-body ">
                                        <p>Identify items that have incorrect GST classification</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-4">
                                <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                    <div className="card-head">
                                        <img className='img-fluid w-50 m-3' src="./assets/images/high-security.png" alt="" />
                                    </div>
                                    <div className="card-body ">
                                        <p>Proactive compliance monitoring</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-4">
                                <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                    <div className="card-head">
                                        <img className='img-fluid w-50 m-3' src="./assets/images/data-management.png" alt="" />
                                    </div>
                                    <div className="card-body ">
                                        <p>Input tax credit analysis & early warning to avoid penalty</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-4">
                                <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                    <div className="card-head">
                                        <img className='img-fluid w-50 m-3' src="./assets/images/data-management.png" alt="" />
                                    </div>
                                    <div className="card-body ">
                                        <p>Overpaid and under-claimed tax</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-5 section-advantage-intelligence-insight p-3">
                <h2 className='text-center'>Advantages</h2>
                <div className="card shadow-lg mt-5 p-5">
                    <ul>
                        <li><p>Maintaining control of your tax processes, identify risks and leverage opportunities</p></li>
                        <li><p>Identifying untapped opportunities and hidden risks and early detection.</p></li>
                        <li><p>Gaining quantitative insights over</p></li>
                        <ul>
                            <li><p>Customer</p></li>
                            <li><p>Vendor</p></li>
                            <li><p>Item master data</p></li>
                        </ul>
                    </ul>
                </div>
            </div>

            <div className="container gstrobo-section-3 bg-light mt-5 text-center pb-5">
                <h1 className='pt-5'><span style={{ color: '#f43f47' }}>GST</span> Products</h1>
                <p className='text-muted'>Ensuring Compliance, Reliability & Efficiency</p>
                <div className="gstrobo-cards">
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/invoice.png" alt="" />
                        <h4 className='mt-3'>GST Software</h4>
                        <Link to='/gst-software'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/real-time-goods.png" alt="" />
                        <h4 className='mt-3'>E-Way Bill Software</h4>
                        <Link to='/e-way-bill-software'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/one-click-icon.png" alt="" />
                        <h4 className='mt-3'>E-Invoicing Software</h4>
                        <Link to='/e-invoicing-software'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/api.png" alt="" />
                        <h4 className='mt-3'>GST & E-Way Bill API</h4>
                        <Link to='/gst-e-way-bill-api'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/reconcile.png" alt="" />
                        <h4 className='mt-3'>Intelligence Insight</h4>
                        <Link to='/intelligence-insight'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/ledger.png" alt="" />
                        <h4 className='mt-3'>Value Added Tools</h4>
                        <Link to='/value-added-tools'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                </div>
            </div>

        </div>
    )
}
export default  IntelligenceInsight;